// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  performanceReportsPlantStatusSubRoute,
  PLANT_STATUS_SUB_PATH
} from '@features/performance-reports'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {
  buildFeatureUrl,
  useSuiteHierarchyId,
  useUpmPlantFromHierarchyId
} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {useUpmHierarchyAreaNavigation} from '@widgets/area-dashboard'
import {Suspense} from 'react'
import {generatePath, RouteObject, useNavigate} from 'react-router'

import {processEngineerDashboardFeatureTranslations} from '../localization'
import {ProcessEngineerAreaDashboard, ProcessEngineerPlantDashboard} from '../pages'

const FEATURE_NAME = 'ProcessEngineerDashboard'

const SuiteProcessEngineerDashboard = ({plantId}: {plantId: string}) => {
  const navigate = useNavigate()

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  // TODO: add navigation for Suite
  // implement: renderRunningTimeTooltipFooter, shiftSummaryHref, myTasksHref
  return (
    <ProcessEngineerPlantDashboard
      plantId={plantId}
      onEquipmentClick={navigateToStoppageAnalysis}
      plantStatusPageHref={PLANT_STATUS_SUB_PATH}
    />
  )
}

const SuiteProcessEngineerAreaDashboard = () => {
  const hierarchyId = useSuiteHierarchyId()
  const navigation = useUpmHierarchyAreaNavigation({
    upmAreaId: hierarchyId ?? undefined,
    getNodeLink: (upmHierarchyId) => buildFeatureUrl(FEATURE_NAME, upmHierarchyId)
  })

  return (
    <ProcessEngineerAreaDashboard
      dashboardRoute={buildFeatureUrl(FEATURE_NAME)}
      navigation={navigation}
    />
  )
}

const SuiteProcessEngineerNodeDashboard = () => {
  const plant = useUpmPlantFromHierarchyId()

  if (plant === undefined) {
    return null
  }

  return plant ? (
    <SuiteProcessEngineerDashboard plantId={plant.plantId} />
  ) : (
    <SuiteProcessEngineerAreaDashboard />
  )
}

const SuiteProcessEngineerDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={processEngineerDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuiteProcessEngineerNodeDashboard />
        </Suspense>
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const processEngineerDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteProcessEngineerDashboardRouteWrapper />
    },
    performanceReportsPlantStatusSubRoute,
    stoppageAnalysisSubRoute
  ]
}
